export default __webpack_public_path__ + "static/media/icon-documents.02894d9b.svg";